<template>
  <div class="full-height">

    <SkillsComponent v-if="!TriggerAdd && MatchingTracks.length > 0"
                     :EmployeeId="1"
                     :HideIfNoTriggers="true"
                     v-for="track in MatchingTracks"
                     :key="track.id"
                     :TriggerUrl="$route.query.triggerurl"
                     :TrackMatrix="track"
                     :Title="track.title"
                     :Description="track.description"
                     :Onboardings="Onboardings"
                     :Workflows="Workflows">

    </SkillsComponent>


    <div v-if="MatchingTracks.length == 0 && !TriggerAdd && !IsRecording && false">
      <h1>
        {{$t('NothingMatchesThisPage')}}
      </h1>
      <br />
      {{$t('YouCanAddInfo')}}
    </div>

    <TipTapChrome v-model="CurrentOnboarding.rawContent"
                  @ShareOnboardingButton="IsEmailPreview = true"
                  @SaveButton="ShowSavePopup"
                  @OpenButton="OpenOnboarding"
                  @OpenAssignMenuButton="OpenAssignMenu"
                  @OpenAssignToRoleMenuButton="OpenAssignToRoleMenuButton"
                  @OpenShareMenuButton="OpenShareMenu"
                  @OpenPropertiesMenuButton="OpenPropertiesMenu"
                  @OpenAddToSpaceMenuButton="OpenAddToSpaceMenu"
                  @RecordingChanged="RecordChanged"
                  @UpdateTitleDescription="UpdateTitleDescription"
                  @AIReview="StartDocInterview"
                  @ShowArtefacts="IsInArtefactDisplay = true"
                  @ShowMatchingItemsForThisUrl="IsInMatchinItemsView = true"
                  @ClearAll="ClearAll"
                  @OpenCameraPopup="OpenCameraPopup"
                  @GeneratePreviewLink="GeneratePreviewLink"
                  @DownloadAll="DownloadAll" @HtmlPaste="HtmlPaste"
                  @DeletOnboardingButton="HandleDelete"
                  @AddIntent="AddIntent"
                  :editable="true"
                  :onboardingId="CurrentOnboarding.id"
                  :title="CurrentOnboarding.name"
                  :description="CurrentOnboarding.description"
                  :properties="CurrentOnboarding.properties"
                  :HideEditorToolBar="true"
                  ref="ChromeEditor"
                  :DiscoveredArtefacts="Artefacts"
                  :ItemsForThisUrl="ItemsForCurrentUrl">

    </TipTapChrome>

    <vs-collapse v-if="false" class="onboarding-recorder" style="border-radius: 8px; padding: 10px;">
      <vs-collapse-item v-for="(step, stepIndex) in HiddenSteps" :key="'s-' + stepIndex" style="background: #efefef; margin-bottom: 10px;">
        <div slot="header" style="background:white; padding:0px; margin:0px;">

        </div>
        <div class="" style="">

          <TipTapChrome v-model="step.request.details.htmlContent" :editable="true" :HideEditorToolBar="false">
          </TipTapChrome>

          <img style="" :src="step.request.screenshot" class="screenshot" v-if="step && step.request && step.request.screenshot && step.request.screenshot.length > 0" />

          <div>
          </div>
        </div>
        <br />
        <div class="step-tools">
          <a @click.stop="HiddenSteps.splice(stepIndex, 1)">Delete Step</a>&nbsp;
          <a v-if="step && step.request && step.request.url" target="_blank" :href="step.request.url">Open target page</a>
        </div>
      </vs-collapse-item>
    </vs-collapse>

    <AddEditAddressView v-if="TriggerAdd" :TriggerUrl="$route.query.triggerurl" :Onboardings="Onboardings" :Workflows="Workflows">
      There is nothing for this website. <a href="">Add it</a>
    </AddEditAddressView>

    <vs-popup :title="$t('ShareAsEmail')" :active.sync="IsEmailPreview" v-if="IsEmailPreview">
      <div class="vx-row">
        <div class="vx-col md:w-1/2 w-full mb-base">
          <vs-input class="vx-col w-1/1 lg:w-1/1" style="width:100%;" :label-placeholder="$t('SubjectLabel')"
                    v-model="Subject" />
        </div>
        <div class="vx-col md:w-1/2 w-full mb-base">
          <vs-input class="vx-col w-1/1 lg:w-1/1" style="width:100%;" :label-placeholder="$t('EmailsCommaSeparated')"
                    v-model="InvitationEmails" />
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col md:w-1/2 w-full mb-base">
          <vs-button @click="SendOnboarding">{{$t('SendEmail')}}</vs-button>
        </div>
      </div>
    </vs-popup>

    <vs-popup :title="$t('PreviewLink')" :active.sync="InPreviewLink" v-if="InPreviewLink">
      <vs-input style="width:100%;" :label-placeholder="$t('PreviewLinkLabel')"
                v-model="previewLink" />
    </vs-popup>

    <vs-popup :title="$t('SavePopupTitle')" :active.sync="InTitleDescriptionMode" v-if="InTitleDescriptionMode">
      <div class="vx-row">
        <div class="vx-col md:w-1/2 w-full mb-base">
          <vs-input class="vx-col w-1/1 lg:w-1/1" style="width:100%;" :label-placeholder="$t('TitleLabel')"
                    v-model="CurrentOnboarding.name" />
        </div>
        <div class="vx-col md:w-1/2 w-full mb-base">
          <vs-input class="vx-col w-1/1 lg:w-1/1" style="width:100%;"
                    :label-placeholder="$t('DescriptionLabel')"
                    v-model="CurrentOnboarding.description" />
        </div>
        <div :active.sync="IsExternal" v-if="IsExternal" class="vx-col w-full mb-base">
          <vs-input class="w-full"
                    style="width: 100%;"
                    :label-placeholder="$t('ExternalUrl')"
                    v-model="externalUrl" />
        </div>
        <div class="vx-col w-full mb-base">
          <vs-button @click="InDomainManagementMode = true"
                     color="primary"
                     type="filled">
            {{$t('ManageNDomains',{count:domainCount})}}
          </vs-button>
        </div>
        <span :active.sync="InSpaceCreationMode" v-if="InSpaceCreationMode">{{$t('SpaceLabel')}}</span>
        <div class="vx-row" :active.sync="InSpaceCreationMode" v-if="InSpaceCreationMode">
          <div class="vx-col md:w-1/2 w-full mb-base">
            <vs-input class="vx-col w-1/1 lg:w-1/1" style="width:100%;" :label-placeholder="$t('TitleLabel')"
                      v-model="spaceTitle" />
          </div>
          <div class="vx-col md:w-1/2 w-full mb-base">
            <vs-input class="vx-col w-1/1 lg:w-1/1" style="width:100%;"
                      :label-placeholder="$t('DescriptionLabel')"
                      v-model="spaceDescription" />
          </div>
        </div>
        <div class="vx-col md:w-1/2 w-full mb-base">
          <vs-checkbox class="vx-col w-1/1 lg:w-1/1" style="width:100%;"
                       v-model="PreviewOnboardingOnSave">{{$t('OpenPreviewInNewTab')}}</vs-checkbox>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col ">
          <vs-dropdown vs-trigger-click='true'>
            <vs-button>{{$t('Publish')}}</vs-button>
            <vs-dropdown-menu style="z-index:99999">
              <vs-dropdown-item @click="SaveAsOnboarding">
                {{$t('Publish')}}
              </vs-dropdown-item>
              <vs-dropdown-item @click="SaveAsDraft(false)">
                {{$t('SaveChangesToVersion',{major:CurrentOnboarding.majorVersion,minor:CurrentOnboarding.minorVersion})}}
              </vs-dropdown-item>
              <vs-dropdown-item @click="SaveAsDraft(true)">
                {{$t('SaveChangesToNewDraft')}}
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>
      </div>

      <!-- Inner popup -->
      <vs-popup :title="$t('ManageDomains')"
                :active.sync="InDomainManagementMode"
                classContent="popup-example domain-management-popup"
                fullscreen>
        <domain-management :rawContent="CurrentOnboarding.rawContent"
                           :visible="InDomainManagementMode"
                           @content-updated="handleDomainContentUpdate" />
      </vs-popup>
    </vs-popup>

    <vs-popup :title="$t('OpenOnboarding')" fullscreen :active.sync="IsOpeningOnboarding" v-if="IsOpeningOnboarding">
      <!--<div class="vx-row">-->

      <vs-input :placeholder="$t('SearchPlaceholder')"
                v-model="searchQuery"
                class="w-full input-rounded-full no-icon-border js-basic-search-input code-search-input"
                icon="icon-search"
                icon-pack="feather"
                @keyup.enter="reSearch(searchQuery, null, 1)" />
      <br />
      <vs-table ref="table"
                pagination
                :max-items="itemsPerPage"
                :data="Onboardings">

        <template slot="thead">
          <vs-th sort-key="name">{{$t('Name')}}</vs-th>
          <!--<vs-th>Description</vs-th>
          <vs-th>Open</vs-th>-->
        </template>
        <template slot-scope="{ data }">
          <tbody>
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td style="vertical-align:top">
                <span :style="onboardingStatusColor(tr.id) " class="dot"></span>
                <p class="product-name font-medium">
                  <a  @click="HandleSelection(tr)" style="cursor:pointer">
                    {{!tr.name || tr.name == '' ? 'Untitled onboarding' : tr.name}}
                  </a>
                  <br />
                  {{tr.description}}
                  <br />
                </p>
                <p class="float-right">{{versionName(tr.minorVersion,tr.majorVersion)}}</p>
              </vs-td>
              <!--<vs-td style="vertical-align:top">

              </vs-td>
              <vs-td style="vertical-align:top">
                <a @click="OpenSelection(tr)" style="cursor:pointer">
                  Open
                </a>
              </vs-td>-->
            </vs-tr>
          </tbody>
        </template>
      </vs-table>
      <!--</div>-->
    </vs-popup>

    <vs-popup :title="$t('ArtefactsDiscovered')" fullscreen :active.sync="IsInArtefactDisplay" v-if="IsInArtefactDisplay">

      <vs-table ref="tableArtefacts"
                pagination
                :max-items="itemsPerPage"
                search
                :data="Artefacts">

        <template slot="thead">
          <vs-th sort-key="name">{{$t('Name')}}</vs-th>
          <vs-th>{{$t('Type')}}</vs-th>
          <vs-th>{{$t('Value')}}</vs-th>
        </template>
        <template slot-scope="{ data }">
          <tbody>
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td style="vertical-align:top">
                <p class="product-name font-medium">
                  {{tr.name}}
                </p>
              </vs-td>
              <vs-td style="vertical-align:top">
                {{tr.type}}
              </vs-td>
              <vs-td style="vertical-align:top">
                {{tr.address}}
              </vs-td>
            </vs-tr>
          </tbody>
        </template>
      </vs-table>
    </vs-popup>

    <vs-popup class="popup-condensed" :title="$t('OnboardingsForThisUrl')" fullscreen :active.sync="IsInMatchinItemsView" v-if="IsInMatchinItemsView">
      <div class="vx-row">
        <vx-card class="m-2" v-for="item in ItemsForCurrentUrl">
          <div class="vs-col-12 mb-10 p-1 w-11/12">
            <div class="card-commands">
              <a @click="OpenSelection(item)"><h4 style="font-weight:900;" class="text-primary pointer">{{item.Name}}</h4></a>
              <p>
                {{item.Description}}
              </p>
              <a :href="'/pages/pdf-view?oid=' + item.Id" target="_blank">{{$t('ViewInNewTab')}}</a>&nbsp;<a href="">{{$t('Edit')}}</a>&nbsp;<a href="">{{$t('GuideMode')}}</a>
            </div>
          </div>
        </vx-card>

      </div>
    </vs-popup>

    <div class="commands" v-if="InEdit">
      <vs-button size="small" class="mr-2" @click.stop="TriggerAdd = true" v-if="!TriggerAdd">
        {{$t('AddStep')}}
      </vs-button>
      <vs-button size="small" @click.stop="TriggerAdd = true" v-if="!TriggerAdd" class="mr-2 btn">
        {{$t('EditStep')}}
      </vs-button>


      vs
      <vs-button size="small" class="mr-2" @click.stop="TriggerAdd = true" v-if="!TriggerAdd">
        {{$t('DeleteStep')}}
      </vs-button>
    </div>

    <!--PORTED FROM ONBOARDING.PDF-->
    <vs-popup :title="$t('ShareOnboarding')" :active.sync="InOnboardingShareMode" v-if="InOnboardingShareMode">
      <ShareComponent :shareObjectType="'0'" :shareObjectId="CurrentOnboarding.id"></ShareComponent>
    </vs-popup>

    <vs-popup :title="$t('AssignOnboarding')" :active.sync="InOnboardingAssignMode" v-if="InOnboardingAssignMode">
      <AssignComponent :shareObjectType="'0'" :shareObjectId="CurrentOnboarding.id"></AssignComponent>
    </vs-popup>

    <vs-popup :title="$t('AssignToRoleTitle')" :active.sync="InAssignToRoleMode" v-if="InAssignToRoleMode">
      <AssignToRoleComponent :shareObjectType="'0'" :shareObjectId="CurrentOnboarding.id"></AssignToRoleComponent>
    </vs-popup>

    <vs-popup :title="$t('AddOnboardingToSpaceTitle')" :active.sync="InOpenAddToSpaceMode" v-if="InOpenAddToSpaceMode">
      <AddOnboardingToSpaceComponent :onboarding_id="CurrentOnboarding.id"></AddOnboardingToSpaceComponent>
    </vs-popup>


    <vs-popup :title="$t('OnboardingProperties')" :active.sync="InPropetiesMode" v-if="InPropetiesMode">
      <TabContainer :onboarding="CurrentOnboarding"></TabContainer>
    </vs-popup>

  </div>
</template>

<script>

  import SkillsComponent from '@/views/components/onboarding-skills/SkillsComponent.vue';
  import AddEditAddressView from '@/views/components/onboarding-skills/AddEditAddressView.vue';
  import TCVelikClient from '@/TCVelikClient/TCVelikClient';
  import TipTapChrome from "@/views/components/extra-components/editors/TipTapChrome.vue";
  import accountsService from '../accounts/accountsService';
  import TCVelikBrowserClient from '@/TCVelikBrowserClient/TCVelikBrowserClient';
  import { EventBus } from '@/eventBus/eventBus.js';
  //PORTED FROM ONBOARIDNG.PDF
  import ShareComponent from '@/views/components/extra-components/share/ShareComponent.vue';
  import AssignComponent from '@/views/components/extra-components/assign/AssignComponent.vue';
  import AddOnboardingToSpaceComponent from '@/views/components/extra-components/onboarding-space/AddOnboardingToSpaceComponent.vue';
  import AssignToRoleComponent from '@/views/components/extra-components/assign/AssignToRoleComponent.vue';
  import TabContainer from '@/views/ui-elements/tabs/TabContainer.vue'
  import DomainManagement from '@/views/components/domain-management/DomainManagement.vue'

  export default {
    data() {
      return {
        IsRecording: false,
        stream: null,
        TriggerAdd: false,
        MatchingTracks: [],
        Workflows: [],
        Onboardings: [],
        HiddenSteps: [],
        InEdit: false,
        IsInArtefactDisplay: false,
        CurrentOnboarding: {
          id: 0,
          name: '',
          description: '',
          properties: '',
          uniqueVersionId: null,
          minorVersion: 0,
          majorVersion: 0
        },
        title: '',
        content: '',
        previewLink: '',
        CurrentStepIs: -1,
        IsEmailPreview: false,
        spaceTitle: "",
        spaceDescription: "",
        IsOpeningOnboarding: false,
        InOnboardingShareMode: false,
        InOpenAddToSpaceMode: false,
        InOnboardingAssignMode: false,
        InAssignToRoleMode: false,
        InPropetiesMode: false,
        InSpaceCreationMode: false,
        Subject: '',
        Description: "",
        facingMode: 'environment',
        InCameraMode: false,
        InvitationEmails: '',
        itemsPerPage: 20,
        CurrentChat: {
          InputTokensTotal: 0,
          OutputTokensTotal: 0,
          Messages: []
        },
        Artefacts: [],
        ItemsForCurrentUrl: [],
        IsInMatchinItemsView: false,
        InTitleDescriptionMode: false,
        InPreviewLink: false,
        SaveAsNewDraft: false,
        PreviewOnboardingOnSave: false,
        searchQuery: "",
        IsExternal: false,
        externalUrl: "",
        InSaveMode: false,
        InDomainManagementMode: false,
        domainCount: 0
      }
    },

    watch: {
      'CurrentOnboarding.name': function (newValue, oldValue) {
        if (newValue != '') {
          EventBus.$emit(`onboarding_editor_title_change`, newValue)
        }
        else {
          EventBus.$emit(`onboarding_editor_title_change`, "No onboarding selected");
        }
      },
      'CurrentOnboarding.rawContent': function (newValue) {
        // Update domain count whenever content changes
        if (newValue) {
          const domains = this.extractDomainsFromContent(newValue);
          this.domainCount = domains.size;
        } else {
          this.domainCount = 0;
        }
      },
      'InCameraMode': function (newValue, oldValue) {
        if (newValue == false) {
          this.stopCamera();
        }
      }
    },

    mounted() {

      var instance = this;

      if (this.$route.query.oid) {
        this.OpenSelection({
          id: this.$route.query.oid
        })
      }

      if (this.$route.query.IsExternal) {
        this.IsExternal = true
      }

      window.addStepDetailsExternal = function (event) {

        var message = JSON.parse(atob(event));
        instance.HiddenSteps.push(message);
        var editor = instance.$refs.ChromeEditor.GetEditorInsance();
        editor.chain().insertContent('<div data-type="draggable-item">' + instance.GetStepHtml(message) + '</div>')
          .focus("end")
          .run();

        editor.chain().keyboardShortcut('Enter').run();
        editor.chain().keyboardShortcut('Enter').run();
      }

      window.addEventListener('message', function (event) {
        const message = event.data;

        if (message && message.type === 'showItem' && instance.IsRecording) {
          instance.HiddenSteps.push(message);
          var editor = instance.$refs.ChromeEditor.GetEditorInsance();

          editor.chain().insertContent('<div data-type="draggable-item">' + instance.GetStepHtml(message) + '</div>')
            .focus("end")
            .run();

          editor.chain().keyboardShortcut('Enter').run();
          editor.chain().keyboardShortcut('Enter').run();
        }
        else if (message && message.action === 'tabReloaded') {
          TCVelikClient.GetRelative("/api/search?query=**&shortResults=true&urlContext=" + message.url)
            .then(function (result) {
              instance.ItemsForCurrentUrl = result.data;
            })
        }
      });

      var triggerUrl = this.$route.query.triggerurl;
      if (triggerUrl && triggerUrl.length > 0) {

        var req = JSON.stringify({
          query: `query OnboardingStepCriteria {
                  onboardingStepCriteria(where: {
                      value:{
                          contains:"${triggerUrl.replace(/"/g, '\\"')}"
                      }
                  }) {
                      id
                      operator
                      value
                      stepId,
                      onboardingStep{
                          id,
                          title,
                          onboarding{
                              id,
                              name,
                              onboardingSteps{
                                  id,
                                  title,
                                  onboardingStepsCriterias{
                                      value,
                                      operator,
                                      id
                                  }
                              }
                          }
                      }
                  }
                   workflows{
                      id,
                      name,
                      shortDescription
                  },
                  onboardings{
                      id,
                      name,
                      description
                  }
              }`});

        TCVelikClient.PostRelative("/api/graphql", req, {
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
          }
        }).then(function (response) {
          if (response && response.data && response.data.data) {
            instance.Workflows = response.data.data.workflows || [];
            instance.Onboardings = response.data.data.onboardings || [];
            instance.MatchingTracks = instance.parseTracks(response.data.data.onboardingStepCriteria)
          }
        });
      }
    },
    methods: {
      reSearch(phrase, query, page) {
        var instance = this;
        TCVelikClient.GetRelative("/api/search?query=" + phrase + "&shortResults=true&urlContext=")
          .then(function (response) {
            if (response && response.data) {
              instance.Onboardings = response.data.map(item => ({
                id: item.Id,
                name: item.Name,
                description: item.Description
              })) || [];

            }
          });
      },
      getElementPositionsCssString(step) {
        var bgX = 'background-position-x:-' + (step.request.details.screenX - step.request.details.width) + 'px;';
        var bgY = 'background-position-y:-' + (step.request.details.screenY - step.request.details.height) + 'px;';
        return bgX + bgY;
      },
      parseTracks(tracksArray) {
        const groupedByOnboarding = tracksArray.reduce((acc, item) => {
          const onboarding = item.onboardingStep.onboarding;
          const key = onboarding ? onboarding.id : 'null';

          if (!acc[key]) {
            acc[key] = {
              onboarding: onboarding,
              steps: []
            };
          }

          acc[key].steps.push(item);
          return acc;
        }, {});

        var result = [];
        var currentUser = accountsService.getUserFromLocalStorage();

        for (var key in groupedByOnboarding) {
          var itm = groupedByOnboarding[key];
          if (itm.onboarding) {
            result.push({
              onboarding: itm.onboarding,
              steps: itm.steps,
              employees: [{
                id: currentUser.user.id,
                avatar: currentUser.user.avatarUrl,
              }] // TODO
            });
          }
        }
        return result;
      },

      onboardingColor(id) {
        if (id >= 0) {
          return;
        }
        else {
          return "color:darkorange"
        }
      },

      onboardingStatusColor(id) {
        if (id >= 0) {
          return " background-color:green";
        }
        else {
          return " background-color:darkorange"
        }
      },

      versionName(min, maj) {
        var min_calc = min || 0
        var maj_calc = maj || 0
        return `${maj_calc}.${min_calc}`

      },

      GeneratePreviewLink() {
        if (this.CurrentOnboarding.id > 0) {
          this.previewLink = window.location.host + '/pages/pdf-view?oid=' + this.CurrentOnboarding.id
        }
        else if (this.CurrentOnboarding.id < 0) {
          this.previewLink = window.location.host + '/pages/pdf-view?uniqueVersionId=' + this.CurrentOnboarding.uniqueVersionId
        }
        else {
          this.$vs.notify({
            title: this.$t('CannotGeneratePreviewForUnsavedOnboarding'),
            color: 'danger',
            iconPack: 'feather',
            position: "top-center",
            icon: "icon-alert-circle",
          });
          return;
        }
        this.InPreviewLink = true
      },

      copyHTMLToClipboard(element) {
        // Select the HTML content
        var content = element.outerHTML;

        // Create a Blob with the HTML content and the correct MIME type
        var blob = new Blob([content], { type: 'text/html' });

        // Create a new ClipboardItem from the Blob
        var clipboardItem = new ClipboardItem({ 'text/html': blob });

        // Use the Clipboard API to write the ClipboardItem to the clipboard
        navigator.clipboard.write([clipboardItem]).then(function () {
          // Provide feedback to the user (optional)
          alert('HTML content copied to clipboard!');
        }).catch(function (err) {
          console.error('Could not copy HTML: ', err);
        });
      },
      copyText(flavor) {
        if (flavor === 'word') {
          const thisIns = this;

          var elmt = document.getElementsByClassName("onboarding-recorder")[0];
          var text = elmt.innerHTML;

          this.copyHTMLToClipboard(text, elmt).then(
            function () {
              thisIns.$vs.notify({
                title: thisIns.$t('SuccessExclamation'),
                text: thisIns.$t('TextCopiedSuccessfully'),
                color: 'success',
                iconPack: "feather",
                position: "top-center",
                icon: "icon-check-circle",
              });
            },
            function (err) {
              thisIns.$vs.notify({
                title: thisIns.$t('Failed'),
                text: thisIns.$t('ErrorInCopyingText') + ' ' + err,
                color: 'danger',
                iconPack: "feather",
                position: "top-center",
                icon: "icon-alert-circle",
              });
            });
        }
      },
      ShareOnboarding() {
        this.IsEmailPreview = true;

      },

      checkCameraSupport() {
        if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
          return false;
        }
        return true;
      },

      OpenCameraPopup() {
        if (!this.checkCameraSupport()) {
          alert("Your browser doesn't support camera access.");
          return;
        }
        this.InCameraMode = true;

        this.$nextTick(() => {
          this.StartCamera()
        });
      },

      async capturePhoto() {
        if (!this.stream) return;

        const videoElement = this.$refs.videoElement;
        const canvas = this.$refs.canvas;

        canvas.width = videoElement.videoWidth;
        canvas.height = videoElement.videoHeight;

        // Draw the current video frame to the canvas
        const context = canvas.getContext('2d', { willReadFrequently: true });
        context.drawImage(videoElement, 0, 0, canvas.width, canvas.height);
        var imageUrl = canvas.toDataURL(canvas);

        this.$refs.ChromeEditor.CreateImageStep(imageUrl)
      },

      canvasToBlob(canvas) {
        return new Promise((resolve) => {
          canvas.toBlob(blob => {
            if (blob) {
              resolve(URL.createObjectURL(blob));
            } else {
              resolve(null);
            }
          }, 'image/jpeg', 0.9);
        });
      },


      switchCamera() {
        this.facingMode = this.facingMode === 'user' ? 'environment' : 'user';
        this.StartCamera();
      },

      async StartCamera() {
        try {
          if (this.stream) {
            this.stopCamera();
          }

          const constraints = {
            video: {
              facingMode: this.facingMode
            }
          };
          this.stream = await navigator.mediaDevices.getUserMedia(constraints);
          this.$refs.videoElement.srcObject = this.stream;

        } catch (error) {
          console.error('Error accessing camera:', error);

          if (error.name === 'NotAllowedError') {
            this.$vs.notify({
              title: this.$t('CameraNotAllowed'),
              color: 'danger',
              iconPack: 'feather',
              position: "top-center",
              icon: "icon-check-circle",
            });
          } else if (error.name === 'NotFoundError' || error.name === 'OverconstrainedError') {
            this.facingMode = this.facingMode === 'user' ? 'environment' : 'user';
            this.StartCamera();
          } else {
            this.$vs.notify({
              title: this.$t('ErrorAccessingCamera'),
              color: 'danger',
              iconPack: 'feather',
              position: "top-center",
              icon: "icon-check-circle",
            });
          }
        }
      },

      stopCamera() {
        if (!this.stream) return;
        this.stream.getTracks().forEach(track => track.stop());
        this.$refs.videoElement.srcObject = null;
        this.stream = null;
      },

      OpenShareMenu() {
        if (this.CurrentOnboarding.id == 0) {
          this.$vs.notify({
            title: this.$t('PleaseOpenAnOnboarding'),
            color: 'warning',
            iconPack: 'feather',
            position: "top-center",
            icon: "icon-check-circle",
          });
          return;
        }
        this.InOnboardingShareMode = true;
      },

      OpenAssignMenu() {
        if (this.CurrentOnboarding.id == 0) {
          this.$vs.notify({
            title: this.$t('PleaseOpenAnOnboarding'),
            color: 'warning',
            iconPack: 'feather',
            position: "top-center",
            icon: "icon-check-circle",
          });
          return;
        }
        this.InOnboardingAssignMode = true;
      },
      OpenAssignToRoleMenuButton() {
        if (this.CurrentOnboarding.id == 0) {
          this.$vs.notify({
            title: this.$t('PleaseOpenAnOnboarding'),
            color: 'warning',
            iconPack: 'feather',
            position: "top-center",
            icon: "icon-check-circle",
          });
          return;
        }
        this.InAssignToRoleMode = true;
      },

      OpenAddToSpaceMenu() {
        if (this.CurrentOnboarding.id == 0) {
          this.$vs.notify({
            title: this.$t('PleaseOpenAnOnboarding'),
            color: 'warning',
            iconPack: 'feather',
            position: "top-center",
            icon: "icon-check-circle",
          });
          return;
        }
        this.InOpenAddToSpaceMode = true;
      },


      OpenPropertiesMenu() {
        if (this.CurrentOnboarding.id == 0) {
          this.$vs.notify({
            title: this.$t('OnboardingNotSavedCannotBeShared'),
            color: 'warning',
            iconPack: 'feather',
            position: "top-center",
            icon: "icon-check-circle",
          });
          return;
        }
        this.InPropetiesMode = true;
      },

      HandleDelete() {
        if (this.CurrentOnboarding.id == 0) {
          this.$vs.notify({
            title: this.$t('PleaseOpenAnOnboarding'),
            color: 'warning',
            iconPack: 'feather',
            position: "top-center",
            icon: "icon-check-circle",
          });
          return;
        }
        else if (this.CurrentOnboarding.id < 0) {
          this.DeleteDraft()
        }
        else {
          this.DeleteOnboarding()
        }

      },

      DeleteDraft() {
        var instance = this;
        if (confirm('Are you sure you want to delete this onboarding?')) {
          const mutation = `mutation DeleteDraft($uvi: UUID!) {
deleteDraft(uvi: $uvi)
}`;

          const variables = {
            uvi: this.CurrentOnboarding.uniqueVersionId 
          };

          const req = {
            query: mutation,
            variables
          };


          return TCVelikClient.PostRelative("/api/graphql", req, {
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json',
            }
          })
            .then(response => {
              instance.$vs.notify({
                title: instance.$t('DraftDeleted'),
                color: 'success',
                iconPack: 'feather',
                position: "top-center",
                icon: "icon-check-circle",
              });
              location.reload()
            })
            .catch(error => {
              this.$vs.notify({
                title: this.$t('ErrorOccurredDeletingDraft'),
                color: 'danger',
                iconPack: 'feather',
                position: "top-center",
                icon: "icon-check-circle",
              });
            });
        } else {
          return;
        }
      },

      DeleteOnboarding() {
       

        var instance = this;
        if (confirm('Are you sure you want to delete this onboarding?')) {
          const mutation = `mutation DeleteOnboarding($id: Int!) {
     deleteOnboarding(id: $id)
     }`;

          const variables = {
            id: this.CurrentOnboarding.id * 1
          };

          const req = {
            query: mutation,
            variables
          };


          return TCVelikClient.PostRelative("/api/graphql", req, {
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json',
            }
          })
            .then(response => {
              instance.$vs.notify({
                title: instance.$t('OnboardingDeleted'),
                color: 'success',
                iconPack: 'feather',
                position: "top-center",
                icon: "icon-check-circle",
              });
              location.reload()
            })
            .catch(error => {
              this.$vs.notify({
                title: this.$t('ErrorOccurredDeletingOnboarding'),
                color: 'danger',
                iconPack: 'feather',
                position: "top-center",
                icon: "icon-check-circle",
              });
            });
        } else {
          return;
        }
      },


      SendOnboarding() {
        var req = {
          Content: this.content,
          Title: this.Subject,
          To: this.InvitationEmails
        };

        TCVelikClient.PostRelative("/api/onboarding/ShareOnboardingRaw", req, {
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
          }
        }).then(function (response) {
          alert('Done');
        });
      },
      DownloadAll() {
        TCVelikClient.Get("/api/export/")
      },
      ClearAll() {
        var instance = this;
        if (confirm('Any unsaved changes will be lost, close anyway?')) {
          instance.CurrentOnboarding = {
            id: 0,
            name: '',
            description: '',
            rawContent: '',
            minorVersion: 0,
            majorVersion: 0
          };
        }
      },
      UpdateTitleDescription(title, description) {
        this.CurrentOnboarding.name = title
        this.CurrentOnboarding.description = description
      },
      Reconnect() {
        window.postMessage({
          type: "reinit"
        })
      },
      CallAI() {
        var payload = [{
          Role: "User",
          Content: this.getAICompliant(this.HiddenSteps)
        }];

        TCVelikClient.PostRelative("/api/OpenAI/ChatWithFunctions", payload).then(function (response) {
          console.log(response);
        });
      },
      StartDocInterview(onboarding) {
        var instance = this;

        var strToPassToAI = '';
        if (!onboarding) {
          strToPassToAI = JSON.stringify(this.GetStepsFromHtml(this.$refs.ChromeEditor.value));
        }
        else {
          strToPassToAI = JSON.stringify(onboarding);
        }

        var prompt = "This is my current onboarding. It is a JSON of the actions I did in a browser." + strToPassToAI;

        if (!instance.CurrentChat) {
          var payload = {
            InputTokens: 0,
            OutputTokens: 0,
            Messages: [{
              Role: "User",
              Content: prompt
            }]
          };
        }
        else {

          if (!instance.CurrentChat.Messages) {
            instance.CurrentChat.Messages = [];
          }

          instance.CurrentChat.Messages.push({
            Role: "User",
            Content: prompt
          });

          payload = JSON.stringify(instance.CurrentChat);
        }

        var options = {
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
          }
        };

        TCVelikClient.PostRelative("/api/OpenAI/ChatWithFunctions", payload, options).then(function (response) {
          if (response && response.data && response.data) {
            instance.CurrentChat = response.data;
            instance.GetDiscoveredArtefacts();
          }
        });
      },
      GetDiscoveredArtefacts() {
        if (this.CurrentChat && this.CurrentChat.Messages && this.CurrentChat.Messages.length > 0) {
          for (var i = 0; i < this.CurrentChat.Messages.length; i++) {
            var msg = this.CurrentChat.Messages[i];
            if (msg.ToolCalls && msg.ToolCalls.length > 0 && !msg.IsProcessed) {
              for (var j = 0; j < msg.ToolCalls.length; j++) {
                var toolCall = msg.ToolCalls[j];
                var toolArgs = JSON.parse(toolCall.FunctionArguments);
                if (toolArgs && toolArgs.artefacts) {
                  for (var k = 0; k < toolArgs.artefacts.length; k++) {
                    this.Artefacts.push(toolArgs.artefacts[k]);
                  }
                }
              }
            }
          }
        }
      },
      getAICompliant(arr) {
        var newArr = [];
        for (var i = 0; i < arr.length; i++) {
          var itm = arr[i];
          if (itm && itm.request && itm.request.screenshot) {
            delete itm.request.screenshot;
          }
          newArr.push(itm);
        }

        return JSON.stringify(newArr);
      },
      ShowSavePopup() {
        //if (this.$acl.check('editor')) {
        //  this.$vs.notify({
        //    title: "Cannot Save Onboarding as a guest user",
        //    color: 'success',
        //    iconPack: "feather",
        //    position: "top-center",
        //    icon: "icon-check-circle",
        //  });
        //  return;
        //}
        this.InTitleDescriptionMode = true;
      },
      SaveAsOnboarding() {
        if (this.IsExternal) {
          if (!URL.canParse(this.externalUrl)) {
            this.$vs.notify({
              title: this.$t('InvalidURL'),
              text: this.$t('PleaseFillInValidURL'),
              color: 'success',
              iconPack: "feather",
              position: "top-center",
              icon: "icon-check-circle",
            });
            return;
          }
          var url = URL.parse(this.externalUrl)
          url.searchParams.delete('IsExternal');
          let props = {
            IsExternal: true,
            ShowOn: [decodeURI(this.$route.query.pageUrl)]
          }
          this.CurrentOnboarding.properties = JSON.stringify(props);
        }

        else if ((this.$route.query.pageUrl || this.$route.query.AttachTo) && !this.IsExternal) {
          // Parse existing properties if any
          let props = {};
          if (this.CurrentOnboarding.properties) {
            try {
              props = JSON.parse(this.CurrentOnboarding.properties);
            } catch (e) {
              props = {};
            }
          }
          
          // Initialize ShowFor array if it doesn't exist
          if (!props.ShowFor) {
            props.ShowFor = [];
          }
          
          // Add pageUrl if present
          if (this.$route.query.pageUrl) {
            const pageUrl = decodeURI(this.$route.query.pageUrl);
            if (!props.ShowFor.includes(pageUrl)) {
              props.ShowFor.push(pageUrl);
            }
          }
          
          // Add AttachTo URL if present (base64 decoded)
          if (this.$route.query.AttachTo) {
            try {
              const decodedUrl = decodeURIComponent(atob(this.$route.query.AttachTo));
              if (!props.ShowFor.includes(decodedUrl)) {
                props.ShowFor.push(decodedUrl);
              }
            } catch (e) {
              console.error('Error decoding AttachTo parameter:', e);
            }
          }
          
          this.CurrentOnboarding.properties = JSON.stringify(props);
        }
        var instance = this;

        const query = `
          mutation AddOnboarding($onboarding:OnboardingInput!) {
            addOnboarding(
              entity:$onboarding) {
              id,
              name
              description
              rawContent
              properties
            }
          }
        `;

        const variables = {
          onboarding: instance.CurrentOnboarding
        };
        const req = {
          query,
          variables
        };

        TCVelikClient.PostRelative("/api/graphql", req, {
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
          }
        }).then(function (response) {
          if (response && response.data && response.data.data) {
            instance.CurrentOnboarding = response.data.data.addOnboarding;
            instance.$vs.notify({
              title: instance.$t('SuccessExclamation'),
              text: instance.$t('OnboardingWasSaved', { name: instance.CurrentOnboarding.name }),
              color: 'success',
              iconPack: "feather",
              position: "top-center",
              icon: "icon-check-circle",
            });
            instance.CurrentOnboarding.majorVersion +=1
            instance.InTitleDescriptionMode = false;
            if (instance.InSpaceCreationMode == true) {
              instance.InSpaceCreationMode = false;
              instance.CreateSpace(instance.CurrentOnboarding.id);
            }
            if (instance.PreviewOnboardingOnSave) {
              window.open('/pages/pdf-view?oid=' + instance.CurrentOnboarding.id);
            }
          }
          else if (response && response.data && response.data.errors) {
            alert('There were some errors saving :( ');
            console.error("ERROR SAVING ONBOARDING: ", response.data);
          }

        });



      },

      SaveAsDraft(newDraft) {
        if (this.IsExternal) {
          if (!URL.canParse(this.externalUrl)) {
            this.$vs.notify({
              title: this.$t('InvalidURL'),
              text: this.$t('PleaseFillInValidURL'),
              color: 'success',
              iconPack: "feather",
              position: "top-center",
              icon: "icon-check-circle",
            });
            return;
          }
          var url = URL.parse(this.externalUrl)
          url.searchParams.delete('IsExternal');
          let props = {
            IsExternal: true,
            ShowOn: [decodeURI(this.$route.query.pageUrl)]
          }
          this.CurrentOnboarding.properties = JSON.stringify(props);
        }

        else if (this.$route.query.pageUrl && !this.IsExternal) {
          let props = {
            ShowFor: [decodeURI(this.$route.query.pageUrl)]
          }
          this.CurrentOnboarding.properties = JSON.stringify(props);
        }
        var instance = this;

        const query = `
  mutation SaveDraft($onboarding:OnboardingVersionInput!,$newDraft:Boolean!) {
    saveDraft(
      entity:$onboarding,newDraft:$newDraft) {

    }
  }
`;

        const variables = {
          onboarding: {
            name: instance.CurrentOnboarding.name,
            description: instance.CurrentOnboarding.description,
            properties: instance.CurrentOnboarding.properties,
            rawContent: instance.CurrentOnboarding.rawContent,
            uniqueVersionId: instance.CurrentOnboarding.uniqueVersionId,
            minorVersion: instance.CurrentOnboarding.minorVersion,
            majorVersion: instance.CurrentOnboarding.majorVersion,
          },
          newDraft: newDraft
        };
        const req = {
          query,
          variables
        };

        TCVelikClient.PostRelative("/api/graphql", req, {
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
          }
        }).then(function (response) {
          if (response && response.data && response.data.data) {
            instance.$vs.notify({
              title: instance.$t('SuccessExclamation'),
              text: instance.$t('OnboardingWasSaved', { name: instance.CurrentOnboarding.name }),
              color: 'success',
              iconPack: "feather",
              position: "top-center",
              icon: "icon-check-circle",
            });
            instance.CurrentOnboarding.minorVersion += 1
            instance.InTitleDescriptionMode = false;
            if (instance.InSpaceCreationMode == true) {
              instance.InSpaceCreationMode = false;
              instance.CreateSpace(instance.CurrentOnboarding.id);
            }
            if (instance.PreviewOnboardingOnSave) {
              window.open('/pages/pdf-view?oid=' + instance.CurrentOnboarding.id);
            }
          }
          else if (response && response.data && response.data.errors) {
            alert('There were some errors saving :( ');
            console.error("ERROR SAVING ONBOARDING: ", response.data);
          }

        });



      },

      GetStepHtml(step) {
        var res = '';
        if (step && step.request && step.request.details && step.request.details.text) {
          var details = step.request.details.text.length > 50 ? step.request.details.text.substr(0, 50) : step.request.details.text;
          res += '<p>Click on <strong><a href="' + step.request.url + '">' + details + '</a></strong></p>';
        }

        if (step && step.request && step.request.screenshot) {
          var newItem = JSON.stringify(step.request);
          var itemObj = JSON.parse(newItem);

          if (itemObj.screenshot) {
            itemObj.screenshot = '';
          }

          res += "<img src='" + step.request.screenshot + "'/>";
          res += "<div>" + JSON.stringify(itemObj) + "</div>";
        }
        else if (res) {
          res += "<div class='hidden'>" + JSON.stringify(step) + "</div>";
        }

        return res;
      },
      RecordChanged(newVal) {
        this.IsRecording = newVal;
        if (this.IsRecording) {
          TCVelikBrowserClient.sendMessage({
            action: "StartRecording",
          }).then(function (response) {

          }).catch(error => {

          });
        }
        else {
          TCVelikBrowserClient.sendMessage({
            action: "StopRecording",
          }).then(function (response) {

          }).catch(error => {

          });
        }
      },
      HtmlPaste(newVal) {
        this.CurrentOnboarding.rawContent = newVal;
      },
      CreateSpace(onboardingId) {
        var instance = this;
        const spaceVariables = {
          id: 0,
          title: instance.spaceTitle,
          description: instance.spaceDescription,
          icon: "",
          urlName: ""
        }
        const query = `
mutation AddSpace($space: SpaceInput!) {
  addSpace(entity: $space) {
    id,
    title,
    description,
    icon,
    urlName
    }
 }
`;
        const variables = {
          space: spaceVariables
        }

        const req = {
          query,
          variables
        };
        TCVelikClient.PostRelative("/api/graphql", req, {
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
          }
        }).then(function (response) {
          if (response && response.data.data) {
            const space = response.data.data.addSpace
            instance.AddOnboardingToSpace(space.id, onboardingId)
          }
          else if (response && response.data && response.data.errors) {
            alert('There were some errors saving :( ');
            console.error("ERROR SAVING ONBOARDING: ", response.data);
          }
        });
      },
      AddOnboardingToSpace(spaceId, onboardingId) {
        var instance = this;
        const query = `
  mutation AddToSpace($onboardingId:Int!,$spaceId:Int!) {
   addToSpace(onboardingId:$onboardingId,spaceId:$spaceId) {
        onboardingId
        spaceId
}
}
`;
        const variables = {
          onboardingId: onboardingId,
          spaceId: spaceId
        }
        const req3 = {
          query,
          variables
        }
        TCVelikClient.PostRelative("/api/graphql", req3, {
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
          }
        }).then(function (response) {
          if (response && response.data.data) {
            instance.$vs.notify({
              title: instance.$t('SuccessfullyCreatedAndAddedOnboardingToSpace'),
              color: 'success',
              iconPack: 'feather',
              position: "top-center",
              icon: "icon-check-circle",
            });
          }
          else {
            alert("A problem occured while adding your onboarding to the Space")
          }

        });

      },

      OpenOnboarding() {
        var instance = this;
        var req = JSON.stringify({
          query: `query OnboardingsAndDrafts {
              onboardingsAndDrafts(order: {
                  lastModified:DESC
              }) {
                id
                name,
                description,
                uniqueVersionId,
                minorVersion,
                majorVersion
              }
            }`});

        TCVelikClient.PostRelative("/api/graphql", req, {
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
          }
        }).then(function (response) {
          if (response && response.data && response.data.data) {
            instance.Onboardings = response.data.data.onboardingsAndDrafts;
          }
        });

        this.IsOpeningOnboarding = true;
      },

      HandleSelection(onboarding) {
        if (onboarding.id >= 0) {
          this.OpenSelection(onboarding)
        }
        else {
          this.OpenDraft(onboarding)
        }
      },

      OpenSelection(onboarding) {

        var instance = this;
        const variables = {
          id: (onboarding.id || onboarding.Id) * 1
        };

        var query =
          `query Onboardings($id:Int!) {
                    onboardings(where: { id: { eq: $id } }) {
                        id
                        name
                        description
                        rawContent
                        fullOnboardingContent
                        properties
                        uniqueVersionId
                        minorVersion
                        majorVersion
                    }
                  }`;

        const req = {
          query,
          variables
        };

        TCVelikClient.PostRelative("/api/graphql", req, {
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
          }
        }).then(function (response) {
          if (response && response.data && response.data.data) {
            instance.CurrentOnboarding = response.data.data.onboardings[0];
            instance.content = response.data.data.onboardings[0].rawContent;
            instance.IsOpeningOnboarding = false;
            instance.IsInMatchinItemsView = false;
            instance.$router.push({
              query: {
                ...instance.$route.query,
                oid: variables.id
              }
            });
          }
        });

        var account = JSON.parse(accountsService.getUserFromLocalStorage());
        TCVelikClient.PostRelative("/api/analytics/OpenedOnboarding?OnboardingId=" + variables.id + "&OnboardingType=0" + "&UserEmail=" + account.User.Email);
      },

      OpenDraft(onboarding) {

        var instance = this;
        const variables = {
          uniqueVersionId: onboarding.uniqueVersionId
        };

        var query =
          `query OnboardingsVersion($uniqueVersionId:UUID!) {
               onboardingsVersion(where: { uniqueVersionId: { eq: $uniqueVersionId } }) {
                   name
                   description
                   rawContent
                   properties,
                   uniqueVersionId,
                   minorVersion,
                   majorVersion
               }
             }`;

        const req = {
          query,
          variables
        };

        TCVelikClient.PostRelative("/api/graphql", req, {
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
          }
        }).then(function (response) {
          if (response && response.data && response.data.data) {
            instance.CurrentOnboarding = response.data.data.onboardingsVersion[0];
            instance.CurrentOnboarding["id"] = onboarding.id
            instance.content = response.data.data.onboardingsVersion[0].rawContent;
            instance.IsOpeningOnboarding = false;
            instance.IsInMatchinItemsView = false;
          }
        });
      },

      GetStepsFromHtml(rawHtmlString) {
        // Create a new DOM parser
        var parser = new DOMParser();
        // Parse the string into an HTML document
        var doc = parser.parseFromString(rawHtmlString, 'text/html');

        // Get all div elements with data-node-view-content attribute
        var divs = doc.querySelectorAll("div[data-type='draggable-item']");

        // Array to hold all JSON objects
        var jsonArray = [];

        // Iterate over each div
        divs.forEach(function (div) {
          // Get all <p> elements within the div
          var paragraphs = div.querySelectorAll('p');
          // Get the last <p> element
          var lastParagraph = paragraphs[paragraphs.length - 1];
          // Get the JSON string from the last <p> element
          var jsonString = lastParagraph.textContent || lastParagraph.innerText;
          try {
            // Parse the JSON string
            var jsonData = JSON.parse(jsonString);
            // Add the parsed JSON object to the array
            jsonArray.push(jsonData);
          } catch (e) {
            console.error("Failed to parse JSON: ", jsonString);
          }
        });

        return jsonArray;
      },

      AddIntent(intent) {
        if (this.CurrentOnboarding.properties) {
          var json = JSON.parse(this.CurrentOnboarding.properties)
          json["Intent"] = intent;
          this.CurrentOnboarding.properties = JSON.stringify(json)
          //this.$vs.notify({
          //  title: "Saved Intent!",
          //  color: "success",
          //  iconPack: "feather",
          //  position: "top-center",
          //  icon: "icon-alert-circle",
          //});
          this.SaveAsOnboarding()
        }
        else {
          this.CurrentOnboarding.properties = JSON.stringify({
            Intent: intent
          })
          this.SaveAsOnboarding()
          //this.$vs.notify({
          //  title: "Saved Intent!",
          //  color: "success",
          //  iconPack: "feather",
          //  position: "top-center",
          //  icon: "icon-alert-circle",
          //});
        }
      },

      OpenDomainManagement() {
        // Update domain count and ensure save popup is open
        this.domainCount = this.extractDomainsFromContent(this.CurrentOnboarding.rawContent).length;
        this.InTitleDescriptionMode = true;
        this.InDomainManagementMode = true;
      },
      extractDomainsFromContent(content) {
        const domains = new Set();
        if (!content) {
          console.log('No content to extract domains from');
          return domains;
        }

        try {
          const parser = new DOMParser();
          const doc = parser.parseFromString(content, 'text/html');
          const stepBlocks = doc.querySelectorAll('[data-type="draggable-item"]');

          stepBlocks.forEach((block, index) => {
            const textContent = block.innerText;

            // Look for URLs in both the text content and any JSON data
            const urlMatches = textContent.match(/"url"\s*:\s*"([^"]+)"/g);
            if (urlMatches) {
              urlMatches.forEach(match => {
                const urlMatch = match.match(/"url"\s*:\s*"([^"]+)"/);
                if (urlMatch) {
                  try {
                    const url = urlMatch[1];
                    const domain = new URL(url).host;
                    domains.add(domain);
                  } catch (e) {
                    console.warn('Invalid URL:', urlMatch[1], e);
                  }
                }
              });
            }
          });

          return domains;
        } catch (error) {
          console.error('Error extracting domains:', error);
          return domains;
        }
      },
      SaveOnboarding() {
        // Implementation of SaveOnboarding method
      },
      handleDomainContentUpdate(updatedContent) {
        this.CurrentOnboarding.rawContent = updatedContent;
        this.InDomainManagementMode = false;
        this.$vs.notify({
          title: this.$t('SuccessExclamation'),
          text: this.$t('DomainLabelsHaveBeenApplied'),
          color: 'success',
          iconPack: "feather",
          position: "top-center",
          icon: "icon-check-circle",
        });
      }
    },
    components: {
      SkillsComponent,
      AddEditAddressView,
      TipTapChrome,
      ShareComponent,
      AssignComponent,
      TabContainer,
      AddOnboardingToSpaceComponent,
      AssignToRoleComponent,
      DomainManagement
    }
  }
</script>
<style>

  .popup-condensed {
    padding: 0px;
    margin: 0px;
  }

  body.tcv-recordPage {
    background: #fff;
    padding: 0px;
  }

  .layout--full-page {
    height: 100%;
  }

  .dot {
    height: 10px;
    width: 10px;
    margin:20px;
    background-color: #bbb;
    float:left;
    border-radius: 50%;
    display: block;
  }

  .onboarding-recorder.email .vs-collapse-item {
    background: white !important;
  }

  .onboarding-recorder.email .vs-collapse-item--header {
    /*font-size: 20px;
    color: black;
    margin-bottom: 10px !important;
    margin-top: 10px !important;*/
    background: white !important;
  }

  .onboarding-recorder.email .step-tools {
    display: none !important;
  }

  .onboarding-recorder.email .icon-header {
    display: none !important;
  }

  .onboarding-recorder.email .screenshot {
    max-width: 300px !important;
  }

  .pointer {
    cursor: pointer;
  }

  .commands {
    position: fixed;
    bottom: 0px;
  }

  .full-height {
    height: 100%;
  }

  vid {
    width: 1000px;
    height: 1000px;
  }

  img.screenshot {
    max-width: 80%;
    opacity: 0.8;
  }

  .onboarding-recorder .vs-collapse-item--header {
    background: #efefef;
    margin-bottom: 10px;
  }

  .domain-management-popup {
    width: 80vw !important;
    max-width: 1200px !important;
    height: 80vh !important;
    max-height: 800px !important;
  }

    .domain-management-popup .vs-popup {
      width: 90% !important;
      max-width: 1000px !important;
      height: 90% !important;
      max-height: 700px !important;
    }

    .domain-management-popup .vs-popup__content {
      height: calc(100% - 60px) !important; /* Account for header */
      overflow-y: auto !important;
    }

  .popup-example {
    padding: 20px;
  }
</style>
